// IngredientBatchModel.js
import React from "react";
import { formatDateDMY } from "../comman/config";

const IngredientBatchModel = ({ showModal, setShowModal, detailList, clearItem, type, page  }) => {

  const handleClose = () => {
    setShowModal(false);
    clearItem(); // Clear the selected item when closing the modal
  };
  if (!showModal) return null;

  // Extract Ingredient and Date from the first item (assuming it's the same for all rows)
  const ingredientName = detailList.length > 0 ? detailList[0].ingredient : "";
  const mealDate = detailList.length > 0 ? detailList[0].date : "";

  console.log("Detail List", detailList);
  const ingredientNameType2 = type === 2 && detailList.length > 0 ? detailList[0].ingredient : "";

  const totalOrderQty =
    type === 2
      ? detailList.reduce((acc, item) => acc + parseFloat(item.order_qty || 0), 0).toFixed(2)
      : null;


  const totalGrossQty =
  type === 1 && page === "dairy_list"
    ? detailList.reduce((acc, item) => acc + parseFloat(item.gross_required_qty || 0), 0)
    .toFixed(2)
    : null;

  return (
    <>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none p-4">
            <div className="relative w-full max-w-4xl mx-auto">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none max-h-[90vh] overflow-hidden">
                {/*header*/}
                <div className="flex items-start justify-between p-4 border-b border-solid border-blueGray-200 rounded-t">
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-50 hover:opacity-100 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={handleClose}
                  >
                    <span className="bg-transparent text-black h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>

                {/* Ingredient & Date Display */}
                {type == 1 && (
                  <div className="p-4 bg-gray-50">
                    <p className="text-lg font-semibold">Ingredient: {ingredientName}</p>
                    <p className="text-lg pt-2">Date: {mealDate}</p>
                  </div>
                )}

                {type === 2 && (
                  <div className="p-4 bg-gray-50">
                    <p className="text-lg font-semibold">Ingredient: {ingredientNameType2}</p>
                    <p className="text-lg pt-2">Total Order Qty: {totalOrderQty}</p>
                  </div>
                )}

                <div className="relative flex-auto overflow-y-auto">
                  {type == 1 && (
                    <>
                      {/* Desktop Table */}
                      <div className="hidden md:block">
                        <table className="border w-full">
                          <thead>
                            <tr className="bg-gray-100">
                              <th className="p-3 text-left">Session</th>
                              <th className="p-3 text-left">Menu Item</th>
                              <th className="p-3 text-left">Gross Required Qty</th>
                              <th className="p-3 text-left">Kit No</th>
                            </tr>
                          </thead>
                          <tbody>
                            {detailList.map((item, index) => (
                              <tr key={index} className="border-b hover:bg-gray-50">
                                <td className="p-3">{item.name}</td>
                                <td className="p-3">{item.item_name}</td>
                                <td className="p-3">{item.gross_required_qty}</td>
                                <td className="p-3">{item.kit_no}</td>
                              </tr>
                            ))}
                          </tbody>
                          {page === "dairy_list" && (
                            <tfoot>
                              <tr className="bg-gray-100 font-bold">
                                <td colSpan="2" className="p-3 text-right">Total:</td>
                                <td className="p-3">{totalGrossQty}</td>
                                <td></td>
                              </tr>
                            </tfoot>
                          )}
                        </table>
                      </div>

                      {/* Mobile Card View */}
                      <div className="md:hidden">
                        {detailList.map((item, index) => (
                          <div key={index} className="border-b border-gray-200 p-4 bg-white">
                            <div className="space-y-2">
                              <div className="flex justify-between">
                                <span className="font-semibold text-gray-600">Session:</span>
                                <span>{item.name}</span>
                              </div>
                              <div className="flex justify-between">
                                <span className="font-semibold text-gray-600">Menu Item:</span>
                                <span className="text-right">{item.item_name}</span>
                              </div>
                              <div className="flex justify-between">
                                <span className="font-semibold text-gray-600">Gross Required Qty:</span>
                                <span>{item.gross_required_qty}</span>
                              </div>
                              <div className="flex justify-between">
                                <span className="font-semibold text-gray-600">Kit No:</span>
                                <span>{item.kit_no}</span>
                              </div>
                            </div>
                          </div>
                        ))}
                        {page === "dairy_list" && (
                          <div className="bg-gray-100 p-4 font-bold">
                            <div className="flex justify-between">
                              <span>Total:</span>
                              <span>{totalGrossQty}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  )}

                  {type == 2 && (
                    <>
                      {/* Desktop Table */}
                      <div className="hidden md:block">
                        <table className="border w-full">
                          <thead>
                            <tr className="bg-gray-100">
                              <th className="p-3 text-left">Meal Date</th>
                              <th className="p-3 text-left">Order ID</th>
                              <th className="p-3 text-left">Order Qty</th>
                            </tr>
                          </thead>
                          <tbody>
                            {detailList.map((item, index) => (
                              <tr key={index} className="border-b hover:bg-gray-50">
                                <td className="p-3">{formatDateDMY(item.date)}</td>
                                <td className="p-3">{item.order_id}</td>
                                <td className="p-3">{item.order_qty}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* Mobile Card View */}
                      <div className="md:hidden">
                        {detailList.map((item, index) => (
                          <div key={index} className="border-b border-gray-200 p-4 bg-white">
                            <div className="space-y-2">
                              <div className="flex justify-between">
                                <span className="font-semibold text-gray-600">Meal Date:</span>
                                <span>{formatDateDMY(item.date)}</span>
                              </div>
                              <div className="flex justify-between">
                                <span className="font-semibold text-gray-600">Order ID:</span>
                                <span>{item.order_id}</span>
                              </div>
                              <div className="flex justify-between">
                                <span className="font-semibold text-gray-600">Order Qty:</span>
                                <span>{item.order_qty}</span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )}

                  {type == 3 && (
                    <>
                      {/* Desktop Table */}
                      <div className="hidden md:block">
                        <table className="border w-full">
                          <thead>
                            <tr className="bg-gray-100">
                              <th className="p-3 text-left">Order ID</th>
                              <th className="p-3 text-left">Purchase ID</th>
                              <th className="p-3 text-left">Purchase Qty</th>
                            </tr>
                          </thead>
                          <tbody>
                            {detailList.map((item, index) => (
                              <tr key={index} className="border-b hover:bg-gray-50">
                                <td className="p-3">{item.order_id}</td>
                                <td className="p-3">{item.purchase_id}</td>
                                <td className="p-3">{item.purchase_qty}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* Mobile Card View */}
                      <div className="md:hidden">
                        {detailList.map((item, index) => (
                          <div key={index} className="border-b border-gray-200 p-4 bg-white">
                            <div className="space-y-2">
                              <div className="flex justify-between">
                                <span className="font-semibold text-gray-600">Order ID:</span>
                                <span>{item.order_id}</span>
                              </div>
                              <div className="flex justify-between">
                                <span className="font-semibold text-gray-600">Purchase ID:</span>
                                <span>{item.purchase_id}</span>
                              </div>
                              <div className="flex justify-between">
                                <span className="font-semibold text-gray-600">Purchase Qty:</span>
                                <span>{item.purchase_qty}</span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )}

                  {type == 4 && page === "dairy_receipt_list" && (
                    <>
                      {/* Desktop Table */}
                      <div className="hidden md:block">
                        <table className="border w-full">
                          <thead>
                            <tr className="bg-gray-100">
                              <th className="p-3 text-left">Order ID</th>
                              <th className="p-3 text-left">Date</th>
                              <th className="p-3 text-left">Order Qty</th>
                            </tr>
                          </thead>
                          <tbody>
                            {detailList.map((item, index) => (
                              <tr key={index} className="border-b hover:bg-gray-50">
                                <td className="p-3">{item.order_id}</td>
                                <td className="p-3">{formatDateDMY(item.date)}</td>
                                <td className="p-3">{item.order_qty}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* Mobile Card View */}
                      <div className="md:hidden">
                        {detailList.map((item, index) => (
                          <div key={index} className="border-b border-gray-200 p-4 bg-white">
                            <div className="space-y-2">
                              <div className="flex justify-between">
                                <span className="font-semibold text-gray-600">Order ID:</span>
                                <span>{item.order_id}</span>
                              </div>
                              <div className="flex justify-between">
                                <span className="font-semibold text-gray-600">Date:</span>
                                <span>{formatDateDMY(item.date)}</span>
                              </div>
                              <div className="flex justify-between">
                                <span className="font-semibold text-gray-600">Order Qty:</span>
                                <span>{item.order_qty}</span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>

                {/*footer*/}
                <div className="flex items-center justify-end p-4 border-t border-solid border-blueGray-200 rounded-b">
                  <button
                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 hover:bg-red-50 rounded"
                    type="button"
                    onClick={handleClose}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default IngredientBatchModel;
